import React from 'react';
import s from './PaginationLines.scss';

export interface PaginationLinesProps {
  activeSlide: number;
  totalSlides: number;
  isRTL?: boolean;
}

export enum PaginationLinesDataHooks {
  Track = 'PaginationLines.Track',
  Indicator = 'PaginationLines.Indicator',
}

interface PaginationLinesCSSProperties extends React.CSSProperties {
  '--lines-total-slides': number;
  '--lines-active-slide': number;
  '--lines-direction-multiplier': number;
}

export const PaginationLines: React.FC<PaginationLinesProps> = ({activeSlide, totalSlides, isRTL}) => {
  const cssVars: PaginationLinesCSSProperties = {
    '--lines-total-slides': totalSlides,
    '--lines-active-slide': activeSlide ?? 0,
    '--lines-direction-multiplier': isRTL ? -1 : 1,
  };

  return (
    <div className={s.track} data-hook={PaginationLinesDataHooks.Track} style={cssVars}>
      <div className={s.indicator} data-hook={PaginationLinesDataHooks.Indicator} />
    </div>
  );
};
